import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const MUSIC_ON_PHONE_LINES_CONTENT_PATH = 'licenses.steps.businessInformation.forms.musicOnPhoneLines';

export const musicOnPhoneLinesSchema = BasicBusinessInformationSchema.extend({
  numberOfPhoneLines: z
    .number({
      required_error: `${MUSIC_ON_PHONE_LINES_CONTENT_PATH}.numberOfPhoneLines.validation.required`,
    })
    .int({ message: `${MUSIC_ON_PHONE_LINES_CONTENT_PATH}.numberOfPhoneLines.validation.required` })
    .min(1, {
      message: `${MUSIC_ON_PHONE_LINES_CONTENT_PATH}.numberOfPhoneLines.validation.minimum`,
    }),
});

export const createMusicOnPhoneLinesDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.MusicOnPhoneLines,
});

export type MusicOnPhoneLinesForm = z.infer<typeof musicOnPhoneLinesSchema>;

export const toPayloadMusicOnPhoneLines = (form: MusicOnPhoneLinesForm, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs().format('YYYY-MM-DD'),
    quantity: form.numberOfPhoneLines ?? 0,
  };
};
